// Red-flag rules for Payment Plan and Payments rows: the value the matched insurer
// report entry states against the row's own value. They colour the insurer report
// columns (premium, commission amount, commission rate) in the grids and in the
// Excel exports of both pages, so screen and sheet always agree.

type RowWithInsurerReport = {
  insurerReportNumber?: string | null;
  [field: string]: any;
};

export const hasInsurerReport = (row: RowWithInsurerReport): boolean =>
  row?.insurerReportNumber !== null &&
  row?.insurerReportNumber !== undefined &&
  row.insurerReportNumber !== "";

const differsFromInsurerReport = (
  row: RowWithInsurerReport,
  ownField: string,
  reportedField: string
): boolean =>
  hasInsurerReport(row) &&
  row[ownField] !== null &&
  row[ownField] !== undefined &&
  row[reportedField] !== null &&
  row[reportedField] !== undefined &&
  row[ownField] !== row[reportedField];

export const premiumAmountDiffersFromInsurerReport = (row: RowWithInsurerReport) =>
  differsFromInsurerReport(row, "premiumAmount", "insurerReportPremiumAmount");

export const premiumAmountWithoutTaxDiffersFromInsurerReport = (
  row: RowWithInsurerReport
) =>
  differsFromInsurerReport(
    row,
    "premiumAmountWithoutTax",
    "insurerReportPremiumAmountWithoutTax"
  );

export const commissionAmountDiffersFromInsurerReport = (row: RowWithInsurerReport) =>
  differsFromInsurerReport(row, "commissionAmount", "insurerReportCommissionAmount");

export const commissionRateDiffersFromInsurerReport = (row: RowWithInsurerReport) =>
  differsFromInsurerReport(row, "commissionRate", "insurerReportCommissionRate");
